import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { rupee } from "@/lib/whatsapp";
import { Button } from "@/components/ui/button";
import { Heart, ShoppingBag, Trash2 } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useApp();

  if (wishlist.length === 0) return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center">
      <Heart className="w-16 h-16 text-sage mx-auto mb-4" />
      <h1 className="font-heading text-4xl text-forest">Your wishlist is empty</h1>
      <p className="text-brown/70 mt-2">Save your favourite organic finds for later.</p>
      <Link to="/shop"><Button className="mt-6 rounded-full h-12 px-8 bg-forest hover:bg-earth text-cream">Explore Products</Button></Link>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-12">
      <h1 className="font-heading text-3xl lg:text-4xl text-forest tracking-tight mb-8">My Wishlist ({wishlist.length})</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
        {wishlist.map((p) => (
          <div key={p.id} className="bg-white rounded-2xl soft-shadow overflow-hidden" data-testid={`wishlist-item-${p.id}`}>
            <Link to={`/product/${p.slug}`} className="block aspect-square bg-sand overflow-hidden"><img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover" /></Link>
            <div className="p-4">
              <span className="text-[11px] uppercase tracking-wide text-olive font-500">{p.brand}</span>
              <Link to={`/product/${p.slug}`} className="font-500 text-ink line-clamp-2 block hover:text-terracotta">{p.name}</Link>
              <div className="text-forest font-600 mt-1">{rupee(p.price)}</div>
              <div className="flex gap-2 mt-3">
                <Button onClick={() => addToCart(p)} className="flex-1 rounded-full h-10 bg-forest hover:bg-earth text-cream" data-testid={`wishlist-add-${p.id}`}><ShoppingBag className="w-4 h-4 mr-1" /> Add</Button>
                <button onClick={() => toggleWishlist(p)} data-testid={`wishlist-remove-${p.id}`} className="w-10 h-10 rounded-full border border-sage/50 flex items-center justify-center hover:bg-sand"><Trash2 className="w-4 h-4 text-terracotta" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
